import React, { useState } from 'react';
import DesktopLayout from '../layouts/DesktopLayout';
import SecurePropertyDetails from '../components/SecurePropertyDetails';

const PropertyDetailsPage = () => {
  // Navigation state
  const [activeNavItem, setActiveNavItem] = useState('properties');

  return (
    <DesktopLayout 
      activeNavItem={activeNavItem}
      setActiveNavItem={setActiveNavItem}
      headerTitle="تفاصيل العقار"
    >
      <SecurePropertyDetails />
    </DesktopLayout>
  );
};

export default PropertyDetailsPage;